import { render, staticRenderFns } from "./SlideAvis.vue?vue&type=template&id=7da03da0&scoped=true&"
import script from "./SlideAvis.vue?vue&type=script&lang=js&"
export * from "./SlideAvis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da03da0",
  null
  
)

export default component.exports